import { render } from "./RecoverAssets.vue?vue&type=template&id=63a5692e&scoped=true"
import script from "./RecoverAssets.vue?vue&type=script&lang=js"
export * from "./RecoverAssets.vue?vue&type=script&lang=js"

import "./RecoverAssets.vue?vue&type=style&index=0&id=63a5692e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a5692e"]])

export default __exports__